"use client";
import { JobStatus } from "@/app/context/GeneratorContext";

interface Props {
  status: JobStatus;
  translations: any;
}

export default function JobStatusBadge({ status, translations }: Props) {
  const statusStyles: Record<JobStatus, string> = {
    [JobStatus.Completed]: "bg-green-600 text-white",
    [JobStatus.Active]: "bg-blue-600 text-white",
    [JobStatus.Failed]: "bg-red-600 text-white",
    [JobStatus.Pending]: "bg-yellow-600 text-white",
    [JobStatus.Delayed]: "bg-orange-600 text-white",
    [JobStatus.Cancelled]: "bg-red-600 text-white",
    [JobStatus.Aborted]: "bg-red-600 text-white",
  };

  return (
    <div
      className={`my-auto rounded rounded-sm px-1 py-0.5 text-center text-xs font-semibold ${statusStyles[status]}`}
    >
      {translations[status]}
    </div>
  );
}
